<div [class]="containerClasses()">
  @if (showStepButtons() && layout() === 'vertical') {
  <button
    type="button"
    (click)="stepUp()"
    [disabled]="
      disabled() || (internalValue() ?? NEGATIVE_INFINITY) >= effectiveMax()
    "
    class="stepper-btn stepper-up"
  >
    <lucide-icon name="chevron-up" [size]="16"></lucide-icon>
  </button>
  }

  <div class="number-input-element-wrapper flex items-center flex-grow h-full">
    @if (isNegative()) {
      <span class="prefix text-inherit">-</span>
    }
    @if (prefixIcon() && currency() !== 'USD') {
    <lucide-icon [name]="prefixIcon()!" class="prefix text-muted"></lucide-icon>
    } @if (prefixText() && currency() !== 'USD') {
    <span class="prefix text-muted">{{ prefixText() }}</span>
    }

    <!-- The Input Element -->
    <input
      type="text"
      inputmode="decimal"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      (ngModelChange)="onValueChange($event)"
      (blur)="onBlur()"
      class="number-input-element h-full w-full bg-transparent focus:outline-none placeholder:text-[hsl(var(--color-muted)/0.6)]"
      [ngModel]="internalValue()"
      [mask]="mask()"
      [thousandSeparator]="thousandSeparator()"
      [prefix]="prefix()"
      [dropSpecialCharacters]="false"
      [allowNegativeNumbers]="min() < 0"
      [max]="effectiveMax()"
      [validation]="true"
    />

    <!-- Suffixes -->
    @if (suffixText()) {
    <span class="suffix text-muted">{{ suffixText() }}</span>
    } @if (suffixIcon()) {
    <lucide-icon [name]="suffixIcon()!" class="suffix text-muted"></lucide-icon>
    }
  </div>

  @if (showStepButtons() && layout() === 'vertical') {
  <button
    type="button"
    (click)="stepDown()"
    [disabled]="disabled() || (internalValue() ?? POSITIVE_INFINITY) <= min()"
    class="stepper-btn stepper-down"
  >
    <lucide-icon name="chevron-down" [size]="16"></lucide-icon>
  </button>
  } @if (showStepButtons() && layout() === 'horizontal') {
  <div class="horizontal-steppers">
    <button
      type="button"
      (click)="stepDown()"
      [disabled]="disabled() || (internalValue() ?? POSITIVE_INFINITY) <= min()"
      class="stepper-btn"
    >
      <lucide-icon name="minus" [size]="16"></lucide-icon>
    </button>
    <div class="stepper-divider"></div>
    <button
      type="button"
      (click)="stepUp()"
      [disabled]="
        disabled() || (internalValue() ?? NEGATIVE_INFINITY) >= effectiveMax()
      "
      class="stepper-btn"
    >
      <lucide-icon name="plus" [size]="16"></lucide-icon>
    </button>
  </div>
  }
</div>
